document.addEventListener('DOMContentLoaded', function () {

  // Quiz logic
  var quizBox = document.querySelector('.quiz-box');
  if (quizBox) {
    var questions = quizBox.querySelectorAll('.quiz-question');
    var result = quizBox.querySelector('.quiz-result');
    var nav = quizBox.querySelector('.quiz-nav');
    var nextBtn = quizBox.querySelector('#nextBtn');
    var backBtn = quizBox.querySelector('#backBtn');
    var stepLabel = quizBox.querySelector('#stepLabel');
    var progressFill = quizBox.querySelector('#progressFill');
    var current = 0;
    var answers = {};

    function updateProgress() {
      progressFill.style.width = ((current + 1) / questions.length * 100) + '%';
      stepLabel.textContent = 'Question ' + (current + 1) + ' of ' + questions.length;
      backBtn.disabled = current === 0;
    }

    questions.forEach(function (q, idx) {
      q.querySelectorAll('.quiz-opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
          q.querySelectorAll('.quiz-opt').forEach(function (o) { o.classList.remove('selected'); });
          opt.classList.add('selected');
          answers[idx] = opt.textContent;
          nextBtn.disabled = false;
        });
      });
    });

    nextBtn.addEventListener('click', function () {
      if (current < questions.length - 1) {
        questions[current].classList.remove('active');
        current++;
        questions[current].classList.add('active');
        nextBtn.disabled = !answers[current];
        updateProgress();
      } else {
        questions[current].classList.remove('active');
        nav.style.display = 'none';
        result.classList.add('active');
      }
    });

    backBtn.addEventListener('click', function () {
      if (current > 0) {
        questions[current].classList.remove('active');
        current--;
        questions[current].classList.add('active');
        nextBtn.disabled = !answers[current];
        updateProgress();
      }
    });

    updateProgress();
  }

  // Product gallery thumbnails
  var mainImage = document.getElementById('mainImage');
  var thumbs = document.querySelectorAll('.gallery-thumbs .thumb');
  if (mainImage && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        mainImage.src = thumb.querySelector('img').src;
      });
    });
  }

  // Quantity selector
  var qtyInput = document.getElementById('qtyVal');
  if (qtyInput) {
    document.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
        var newVal = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        qtyInput.value = newVal;
      });
    });
  }

  // Sticky add-to-cart bar
  var stickyBar = document.getElementById('stickyBar');
  var heroSection = document.querySelector('.product-hero');
  if (stickyBar && heroSection) {
    window.addEventListener('scroll', function () {
      var trigger = heroSection.offsetTop + heroSection.offsetHeight;
      if (window.scrollY > trigger) {
        stickyBar.classList.add('show');
      } else {
        stickyBar.classList.remove('show');
      }
    });
  }

  // Purchase option toggle (visual only — connect to a subscriptions app for real functionality)
  document.querySelectorAll('.toggle-opt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      document.querySelectorAll('.toggle-opt').forEach(function (o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
    });
  });

});
